/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_sort_price_asc = /** @type {(inputs: {}) => string} */ () => {
	return `Cena vzestupně`
};

const da_sort_price_asc = /** @type {(inputs: {}) => string} */ () => {
	return `Pris stigende`
};

const de_sort_price_asc = /** @type {(inputs: {}) => string} */ () => {
	return `Preis aufsteigend`
};

const en_sort_price_asc = /** @type {(inputs: {}) => string} */ () => {
	return `Price low to high`
};

const es_sort_price_asc = /** @type {(inputs: {}) => string} */ () => {
	return `Precio ascendente`
};

const fr_sort_price_asc = /** @type {(inputs: {}) => string} */ () => {
	return `Prix croissant`
};

const hu_sort_price_asc = /** @type {(inputs: {}) => string} */ () => {
	return `Ár növekvő`
};

const it_sort_price_asc = /** @type {(inputs: {}) => string} */ () => {
	return `Prezzo crescente`
};

const nl_sort_price_asc = /** @type {(inputs: {}) => string} */ () => {
	return `Prijs oplopend`
};

const pl_sort_price_asc = /** @type {(inputs: {}) => string} */ () => {
	return `Cena rosnąco`
};

const pt_sort_price_asc = /** @type {(inputs: {}) => string} */ () => {
	return `Preço crescente`
};

const sv_sort_price_asc = /** @type {(inputs: {}) => string} */ () => {
	return `Pris stigande`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const sort_price_asc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sort_price_asc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("sort_price_asc", locale)
	if (locale === "cs") return cs_sort_price_asc(inputs)
	if (locale === "da") return da_sort_price_asc(inputs)
	if (locale === "de") return de_sort_price_asc(inputs)
	if (locale === "en") return en_sort_price_asc(inputs)
	if (locale === "es") return es_sort_price_asc(inputs)
	if (locale === "fr") return fr_sort_price_asc(inputs)
	if (locale === "hu") return hu_sort_price_asc(inputs)
	if (locale === "it") return it_sort_price_asc(inputs)
	if (locale === "nl") return nl_sort_price_asc(inputs)
	if (locale === "pl") return pl_sort_price_asc(inputs)
	if (locale === "pt") return pt_sort_price_asc(inputs)
	return sv_sort_price_asc(inputs)
};
export { sort_price_asc as "sort.price_asc" }